export function logAddToCart(order) {
  try {
    window.dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
    window.dataLayer.push({
      event: "add_to_cart",
      ecommerce: {
        currency: "USD",
        value: order.total,
        items: order.items.map(item => {
          return {
            item_id: item.id,
            item_name: item.designName,
            affiliation: "MustHaveMenus",
            item_category: item.paperSize,
            item_category2: item.paperType,
            item_category3: item.pagination,
            price: item.price,
            quantity: item.quantity
          }
        })
      },
    });
  } catch (error) { }
}

export function logRemoveFromCart(order) {
  try {
    window.dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
    window.dataLayer.push({
      event: "remove_from_cart",
      ecommerce: {
        currency: "USD",
        value: order.total,
        items: order.items.map(item => {
          return {
            item_id: item.id,
            item_name: item.designName,
            affiliation: "MustHaveMenus",
            item_category: item.paperSize,
            item_category2: item.paperType,
            item_category3: item.pagination,
            price: item.price,
            quantity: item.quantity
          }
        })
      },
    });
  } catch (error) { }
}